import palette from '../../palette';

export default {
  root: {
    fontSize: "15px",
    "&:hover": {
      color: palette.greenMain,
      backgroundColor: "transparent"
    },
    "&$selected": {
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "transparent"
      },
    }
  },
};